import { createAction, props } from '@ngrx/store';
import { AutoBlockSetting } from './model';

export const loadUsersAutoBlock = createAction('[User Auto-block] Load', props<{ _tenant: string }>());

export const loadUsersAutoBlockSuccess = createAction(
    '[User Auto-block] Load Success',
    props<{ _tenant: string; data: AutoBlockSetting[] }>(),
);

export const loadUsersAutoBlockFailure = createAction(
    '[User Auto-block] Load Failure',
    props<{ _tenant: string; error: AutoBlockSetting }>(),
);

export const enableUsersAutoBlock = createAction(
    '[User Auto-block] Enable Users Auto-blo',
    props<{ _tenant: string; users: AutoBlockSetting[] }>(),
);

export const enableUsersAutoBlockSuccess = createAction(
    '[User Auto-block] Enable Users Auto-block Success',
    props<{ _tenant: string; users: AutoBlockSetting[] }>(),
);

export const enableUsersAutoBlockFailure = createAction(
    '[User Auto-block]  Enable Users Auto-block Failure',
    props<{ _tenant: string; error: any }>(),
);

export const disableUsersAutoBlock = createAction(
    '[User Auto-block] Disable Users Auto-block',
    props<{ _tenant: string; users: Pick<AutoBlockSetting, 'upn' | 'userId'>[] }>(),
);

export const disableUsersAutoBlockSuccess = createAction(
    '[User Auto-block] Disable Users Auto-block Success',
    props<{ _tenant: string; users: AutoBlockSetting[] }>(),
);

export const disableUsersAutoBlockFailure = createAction(
    '[User Auto-block]  Disable Users Auto-block Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateLastModifiedUserAutoBlock = createAction(
    '[User Auto-block] Update Last Modified User Auto-block',
    props<{ _tenant: string; data: { userId: string; upn: string } }>(),
);

export const updateLastModifiedUserAutoBlockSuccess = createAction(
    '[User Auto-block] Update Last Modified User Auto-block Success',
    props<{ _tenant: string; user: AutoBlockSetting }>(),
);

export const updateLastModifiedUserAutoBlockFailure = createAction(
    '[User Auto-block]  Update Last Modified User Auto-block Failure',
    props<{ _tenant: string; error: any }>(),
);
